import React from 'react';
import { MessageSquare, FileText, Megaphone, UserCheck, Settings2, Bell } from 'lucide-react';

// Gemeinsame Darstellung je Kategorie – Glocke (Dropdown) und Seite „Benachrichtigungen“
export const KATEGORIE_META = {
  vorgaenge: { label: 'Vorgang', Icon: MessageSquare, cls: 'bg-sky-50 text-sky-700 ring-sky-100' },
  dokumente: { label: 'Dokument', Icon: FileText, cls: 'bg-emerald-50 text-emerald-700 ring-emerald-100' },
  mitteilungen: { label: 'Mitteilung', Icon: Megaphone, cls: 'bg-amber-50 text-amber-700 ring-amber-100' },
  zuweisungen: { label: 'Zuweisung', Icon: UserCheck, cls: 'bg-violet-50 text-violet-700 ring-violet-100' },
  system: { label: 'System', Icon: Settings2, cls: 'bg-gray-100 text-gray-600 ring-gray-200' },
};

export const kategorieMeta = (n) => KATEGORIE_META[n?.kategorie] || { label: 'Hinweis', Icon: Bell, cls: 'bg-gray-100 text-gray-600 ring-gray-200' };

export const relativeTime = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const diff = Date.now() - date.getTime();
  if (Number.isNaN(diff)) return '';
  if (diff < 60000) return 'gerade eben';
  if (diff < 3600000) return `vor ${Math.floor(diff / 60000)} Min.`;
  if (diff < 86400000) return `vor ${Math.floor(diff / 3600000)} Std.`;
  const d = new Date(date); d.setHours(0, 0, 0, 0);
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const days = Math.round((t - d) / 86400000);
  if (days === 1) return `gestern, ${date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}`;
  if (days < 7) return date.toLocaleDateString('de-DE', { weekday: 'long' });
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const NotificationIcon = ({ n, size = 'md' }) => {
  const { Icon, cls } = kategorieMeta(n);
  const dim = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
  const ic = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const alert = n?.type === 'alert' && n?.kategorie !== 'mitteilungen';
  return (
    <div className={`${dim} rounded-full flex items-center justify-center flex-shrink-0 ring-1 ${alert ? 'bg-red-50 text-red-600 ring-red-100' : cls}`}>
      <Icon className={ic} />
    </div>
  );
};
